import { ROUTE } from "../../routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const GoToNumber = async (action, _datastore, { navigate, goBack }) => {
    // await goBack();
    await AsyncStorage.setItem('first_time', 'true');
    navigate(ROUTE.SPLASH_SCREEN);
};
